define.alias("shared/components/shared/button/copy", "media/components/shared/button/copy");